"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFormats = exports.FORMATS = void 0;
const date_fns_1 = require("date-fns");
// All examples shown for July 4th, 2021 at 4:15pm
// const FORMATS_OLD: { [name: string]: string } = {
//   longScheduledOrder: 'MMM Do, YYYY', // Jul 4th, 2021
//   longScheduledOrderWithTime: 'h:mm A, MMM Do, YYYY', // 4:15 PM, Jul 4th, 2021
//   genericTimeFormat: 'h:mm A', // 4:15 PM
//   shortDateFormat: 'M/D/YYYY', // 7/4/2021
//   voucherCardLastOrder: 'M/D/YY h:mma', // 7/4/21 4:15pm
//   dateOfBirth: 'MMMM D, YYYY', // July 4, 2021
//   scheduledOrderSummaryDate: 'ddd, MMM D', // Sun, Jul 4
// };
exports.FORMATS = {
    longScheduledOrder: 'MMM do, yyyy',
    longScheduledOrderWithTime: 'h:mm a, MMM do, yyyy',
    genericTimeFormat: 'h:mm a',
    shortDateFormat: 'M/d/yyyy',
    voucherCardLastOrder: 'M/d/yy h:mmaaa',
    dateOfBirth: 'MMMM d, yyyy',
    scheduledOrderSummaryDate: 'eee, MMM d',
    orderHistoryDateAndTime: 'M/d/yyyy • h:mm a', // 7/4/2021 • 4:15 PM
};
exports.DateFormats = {
    longScheduledOrder: (date) => (0, date_fns_1.format)(date, exports.FORMATS.longScheduledOrder),
    longScheduledOrderWithTime: (date) => (0, date_fns_1.format)(date, exports.FORMATS.longScheduledOrderWithTime),
    orderHistoryDateAndTime: (date) => (0, date_fns_1.format)(date, exports.FORMATS.orderHistoryDateAndTime),
    genericTimeFormat: (date) => (0, date_fns_1.format)(date, exports.FORMATS.genericTimeFormat),
    shortDateFormat: (date) => (0, date_fns_1.format)(date, exports.FORMATS.shortDateFormat),
    voucherCardLastOrder: (date) => (0, date_fns_1.format)(date, exports.FORMATS.voucherCardLastOrder),
    dateOfBirth: (date) => (0, date_fns_1.format)(date, exports.FORMATS.dateOfBirth),
    scheduledOrderSummaryDate: (date) => (0, date_fns_1.format)(date, exports.FORMATS.scheduledOrderSummaryDate),
};
//# sourceMappingURL=DateFormats.js.map